import * as ko from 'knockout';

import BaseInputBindableArgs from './baseInputBindableArgs';

export default abstract class BaseInputBindable {
    public readonly isRequired: ko.Observable<boolean>;
    public readonly validationError: ko.Computed<boolean>;
    public readonly showValidationError: ko.Computed<boolean>;
    public readonly labelText: ko.Observable<string>;
    public readonly baseValidationErrorText: ko.Observable<string>;
    public readonly hasFocus: ko.Observable<boolean> = ko.observable(false);
    public readonly isLoading: ko.Observable<boolean>;
    public readonly canChange: ko.Observable<boolean> = ko.observable(true);
    public readonly customValidationErrorMessage: ko.Observable<string>;
    public readonly validationErrorText: ko.Computed<string>;
    public readonly placeholder: ko.Observable<string>;
    public readonly automationId: ko.Observable<string>;

    // if true the current validation state will be visible to the user
    protected readonly showValidationState: ko.Observable<boolean> = ko.observable(false);

    constructor(args: BaseInputBindableArgs) {
        this.updateCanChange(args.canChange);
        this.isLoading = ko.observable(true);
        this.labelText = ko.observable(args.labelText);
        this.baseValidationErrorText = ko.observable(args.validationErrorText || null);
        this.isRequired = ko.observable(args.isRequired || false);
        this.validationError = ko.computed(() => !this.isLoading() && this.hasValidationError());
        this.showValidationError = ko.computed(() => this.showValidationState() && this.validationError());
        this.hasFocus.subscribe(this._hasFocusChanged, this);
        this.customValidationErrorMessage = ko.observable('');
        this.validationErrorText = ko.computed(()=> this.customValidationErrorMessage() || this.baseValidationErrorText());
        this.automationId = ko.observable(args.automationId);
    }

    public validate(): boolean {
        this.showValidationState(true);
        return !this.validationError();
    }

    protected hasValidationError(): boolean {
        return !!this.customValidationErrorMessage();
    }

    protected updateCanChange(canChange?: boolean): void {
        // Ignore canChange if it is null, undefined or anything else that is not an explicit true or false.
        if (true === canChange) {
            this.canChange(true);
        }
        else if (false === canChange) {
            this.canChange(false);
        }
    }

    private _hasFocusChanged(newValue: boolean) {
        // Make the validation visible when we lose focus
        if (!newValue) {
            this.showValidationState(true);
        }
    }
}